import apiClient from './apiClient';

export const listWarehouses = async (includeInactive = true) => {
  const res = await apiClient.get(`/warehouses?include_inactive=${includeInactive}`);
  return res.data;
};

export const createWarehouse = async (payload) => {
  const res = await apiClient.post('/warehouses', payload);
  return res.data;
};

export const updateWarehouse = async (warehouseId, payload) => {
  const res = await apiClient.put(`/warehouses/${warehouseId}`, payload);
  return res.data;
};

export const deleteWarehouse = async (warehouseId, hard = false) => {
  const res = await apiClient.delete(`/warehouses/${warehouseId}?hard=${hard}`);
  return res.data;
};

export const getInwardWarehouseSummary = async () => {
  const res = await apiClient.get('/documentation/warehouse-summary');
  return res.data;
};

export const getOutwardWarehouseSummary = async () => {
  const res = await apiClient.get('/outward-documentation/warehouse-summary');
  return res.data;
};

// ---- Admin: bulk re-tag legacy "Unmapped" inward entries ----
export const getUnmappedCount = async () => {
  const res = await apiClient.get('/warehouses/unmapped-count');
  return res.data;
};

export const getUnmappedEntries = async (params = {}) => {
  const res = await apiClient.get('/warehouses/unmapped-entries', { params });
  return res.data;
};

export const bulkRetagEntries = async (entryIds, warehouseId) => {
  const res = await apiClient.post('/warehouses/bulk-retag', {
    entry_ids: entryIds,
    warehouse_id: warehouseId,
  });
  return res.data;
};

